module.exports = __webpack_public_path__ + "img/WaveSVGMask.39ac5c76.svg";